import axios from '@axios'
import axiosRu from '@axios-ru'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMovies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovie(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createMovie(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieDetails(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieSequels(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/sequels`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieFromKP(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/import-from-kp/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieFromKPDev(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/import-from-kp/${id}?with_staff=1&themes=1&api=kp-dev`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadStaffFromKP(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/load-staff/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadFramesFromKP(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/load-frames`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieWithStaff(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}?with_staff=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFrames(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/frames`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    toggleFrame(ctx, {movie_id, id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${movie_id}/frame/${id}/toggle`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesPremiers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/premiers', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesTop(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/top', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesFilter(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/filter', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchMovies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/search', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePerson(ctx, {id, data}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/person/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
